import React, { useEffect, useState } from 'react';
import jwt from 'jsonwebtoken';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';

import './Transactions.scss';
import { RootState } from 'src/configs/store';
import RetailPage from 'src/containers/Page/RetailPage';
import TillHistory from './components/TillHistory/TillHistory';
import TillOverview from './components/TillOverview/TillOverview';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import TransactionContext from './context/Transactions.context';
import SessionAddTransaction from '../AdminSession/ModaslSession/SessionAddTransaction';
import ModalContainer from '../AdminSession/ModaslSession/ModalContainer';

function Transactions() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [showTransactions, setShowTransactions] = useState(false);

  const { tillUser } = useSelector((state:RootState) => state.auth);
  const { transactionTypeList } = useSelector((state:RootState) => state.account);
  const { tillHistory } = useSelector((state:RootState) => state.peripherals);

  const decodedToken: any = jwt.decode(tillUser);

  const [dates, setDates] = useState({
    startDate: +localStorage.getItem('firstLogin'),
    endDate: new Date()
  });
  const [filterType, setFilterType] = useState('');

  const loadTransactionTypes = async () => {
    if (_.isEmpty(transactionTypeList)){
      await dispatch.account.getTransactionTypes();
    }
  };

  useEffect(() => {
    if (!tillHistory && localStorage.getItem('fakeTill') !== 'true'){
      history.goBack();
    }
  }, [tillHistory]);

  useEffect(() => {
    loadTransactionTypes();
  });

  const context = {
    dates,
    setDates,
    filterType,
    setFilterType
  };

  return (
    <RetailPage>
      <BreadCrumb breadcrumbs={ [{ name: t('retail.home'), link:'/' }, { name: t('retail.transactions'), link:'' }] } />
      <div className="transactions">
        <button
          type="button"
          className="btn btn--primary-revert transactions__button transactions__button--small"
          onClick={ () => setShowTransactions(!showTransactions) }
        >
          { t('transactions.addTransaction') }
        </button>
        {
          showTransactions &&
          <ModalContainer title={ t('adminSession.addTransaction') } handleClose={ () => setShowTransactions(false) } size="wide">
            <SessionAddTransaction showButton={ false } />
          </ModalContainer>
        }
        <div className="transactions__double-tables">
          <TransactionContext.Provider value= { context }>
            <TillOverview userName={ decodedToken.username } loginTime={ +localStorage.getItem('firstLogin') } />
            <TillHistory loginTime={ +(localStorage.getItem('sessionStart')) } defaultOrder="Desc" />
          </TransactionContext.Provider>
        </div>
      </div>
    </RetailPage>
  );
}

export default Transactions;
